import { getStorage, removeStorage } from "./storage";
import { allBaseUrl } from "@/config/apiDomain";
import decrypt from "./decrypt";
import { openLoginDialog } from "@/components/Dialogues/useData/login";
import useStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import { isTest } from "@/data/pubilc";
import _ from "lodash";
import { addEncryptUrl } from "@/utils/requestCrypto";
import { ElMessage } from "element-plus";
import axios from "@/../node_modules/axios";
import { AxiosResponse } from "@/../node_modules/axios";
const http = axios.create({
  timeout: 10000,
});

const getHttpType = (value: any) => {
  const data = value as { httpType: string | undefined };
  const result = data.httpType === undefined ? "gptApi" : data.httpType;
  return result;
};

const addEkeyAndSoftId = (url: string) => {
  const unHaveParams = url.indexOf("?") === -1;
  if (unHaveParams)
    return url + `?ekey=${getStorage("ekey")}&soft_id=${getStorage("soft_id")}`;
  let addUrl = url;
  const unHaveEkeys = url.indexOf("ekey=") === -1;
  if (unHaveEkeys) addUrl += `&ekey=${getStorage("ekey")}`;
  const unHaveSoftId = url.indexOf("soft_id=") === -1;
  if (unHaveSoftId) addUrl += `&soft_id=${getStorage("soft_id")}`;
  return addUrl;
};

const getContentType = (value: any) => {
  const data = value as { ContentType: string | undefined };
  const result = data.ContentType || undefined;
  return result;
};

// request interceptor
http.interceptors.request.use(
  (config) => {
    config.url = addEkeyAndSoftId(config.url as string);
    const httpType = getHttpType(config);

    const isEncode = allBaseUrl[httpType].isEncode;
    config.baseURL = allBaseUrl[httpType].url;
    if (httpType === "custom") {
      config.baseURL = config.url;
      config.url = config.url.replace(config.baseURL, "");
    }
    if (getStorage("token")) {
      config.headers["Authorization"] = getStorage("token");
    }
    if (getContentType(config)) {
      config.headers["Content-Type"] = getContentType(config);
    }

    if (httpType === "gptApi") {
      config.headers["Content-Type"] = "application/json";
      const {
        url: encryptUrl,
        data: encryptData,
        header: encryptHeader,
      } = addEncryptUrl({
        url: config.baseURL + config.url,
        data: config.data,
        header: config.headers,
      });

      config.url = encryptUrl.replace(config.baseURL as string, "");
      config.data = encryptData;
      config.headers = encryptHeader;
    }

    // 不能使用isTest的
    let flag = false;
    ["/api/util/generateUrlQRcode"].forEach((item) => {
      if (config.url?.includes(item)) {
        flag = true;
      }
    });
    // 本地运行是，drawSquareApi 也不自动解密，避免本地缓存
    if (
      httpType !== "gptApi" &&
      isTest.value &&
      !flag &&
      isEncode &&
      !config.baseURL?.includes(allBaseUrl["drawSquareApi"].url)
    ) {
      config.headers["aTyE61q0WmqRnz9Y"] = "BFR3vkiBY73GGeNm";
    }
    config.headers["Content-Type"] = "application/json";

    if (!config.data) {
      config.data = {};
    }

    return config;
  },
  (error) => {
    return Promise.reject(error.message);
  }
);

const logout = _.throttle(
  () => {
    const publicStore = useStore();
    const { isLogin } = storeToRefs(publicStore);
    if (!isLogin.value) return;
    ElMessage.error("登录信息已过期，请重新登录");
    openLoginDialog();
    isLogin.value = false;
    removeStorage("token");
  },
  1000,
  { leading: true, trailing: false }
);

const whiteList = ["/api/v2/conversation"];

// response interceptor
http.interceptors.response.use(
  (response: AxiosResponse) => {
    const httpType = getHttpType(response.config);
    const isEncode = allBaseUrl[httpType].isEncode;
    const res: any = response.data;
    let dataStatus = 0;

    const url = response.config.url || "";
    for (let i = 0; i < whiteList.length; i++) {
      const white = whiteList[i];
      if (url.includes(white)) {
        dataStatus = 1;
        break;
      }
    }

    if (res) {
      if (res.code === 403) {
        logout();
        return Promise.reject({
          code: 403,
          msg: "请先登录",
        });
      } else if (res.code > 300) {
        return Promise.reject(res);
      }
      let result = null;
      const data = response.data.data;
      result = data;
      if (dataStatus === 1) {
        return Promise.resolve(decrypt(result));
      }
      // 本地运行是，drawSquareApi 也不自动解密，避免本地缓存
      if (
        httpType === "drawSquareApi" ||
        httpType === "gptApi" ||
        (isEncode && !isTest.value)
      ) {
        result = decrypt(data);
      }
      if (!result) {
        console.log("res = ", res);
        return Promise.resolve({});
      }
      const code = (result as any).code;
      if (code === 403) {
        logout();
        return Promise.reject({
          code: 403,
          msg: "请先登录",
        });
      } else if (code > 300) {
        return Promise.reject(result);
      }
      return Promise.resolve(result);
    } else {
      const error = (response as any).error;
      return Promise.resolve(error);
    }
  },
  (error) => {
    return Promise.reject({
      code: error.code,
      msg: error.message,
    });
  }
);
export default http;
